"use client";

import { Card } from "@/components/ui/card";
import Banner from "./Banner";
import Header from "./Header";
import Content from "./Content";
import Footer from "./Footer";
import { toast } from "react-toastify";

let errorShown = false;

const CatalogCard = ({ product, currentIndex, singleProduct }) => {
  if (!product) return null;

  if ((product.image && product.image.url) || (product.video && product.video.src)) { 
    return <Banner data={product} />;
  }

  if (!product.pk) return null;

  const onMouseLeave = (e, index) => {
    const card = document.querySelector(`.card-no-${index}`);
    const currentVideo = card.querySelector("video");
    if (currentVideo) {
      const pausePromise = currentVideo.pause();
      if (pausePromise !== undefined) {
        pausePromise
          .then((_) => {})
          .catch((error) => {
            console.error("Failed to Pause: " + error);
          });
      }
    }
  };

  const onMouseEnter = (e, index) => {
    const card = document.querySelector(`.card-no-${index}`);
    const currentVideo = card.querySelector("video");
    if (currentVideo) {
      const playPromise = currentVideo.play();
      if (playPromise !== undefined) {
        if (currentVideo.previousSibling.classList.contains("spinner")) {
          currentVideo.previousSibling.style.display = "none";
        }
        playPromise.catch(() => {
          currentVideo.load();
          currentVideo.play().catch((error) => {
            if (
              !errorShown &&
              error?.name?.toLowerCase() === "notallowederror"
            ) {
              errorShown = true;
              toast.info(
                "Please disable low power-mode to allow the Auto-Play feature",
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                }
              );
            }
          });
        });
      }
    }
  };

  return (
    <Card
      className={`
        group w-full border-gray-300 overflow-hidden 
        relative sans relative catalog-card 
        card-no-${currentIndex}
      `}
      onMouseLeave={(e) => onMouseLeave(e, currentIndex)}
      onMouseEnter={(e) => onMouseEnter(e, currentIndex)}
    >
        <article
          data-category={product.category?.name}
          data-name={product.name}
          data-pk={product.pk}
          data-price={product.price}
          className="catalog-products"
        >
          <Header
            name={product.name}
            price={product.price}
            pdp_url={product.pdp_url}
            images={product.images}
            card_tags={product.card_tags}
            pk={product.pk}
            category={product.category}
          />
          <div
            className={`
              w-full bg-white bottom-0 p-2
              sm:p-[0.6rem] 
              group-hover:absolute
              duration-100 ease-in-out 
              ${singleProduct && "group-hover:relative"}
              z-[5] bg-white relative
            `}
          >
            <Content
              rating={product.rating_data}
              name={product.name}
              price={product.price}
              mrp={product.mrp}
              description={product.description}
            />
            <Footer 
              name={product.name}
              pk={product.pk}
              productSlug={product.slug}
              category={product.category}
              price={product.price}
            />
          </div>
        </article>
    </Card>
  );
};

export default CatalogCard;
